export default `
<a ng-show="item.current_user_permissions.hide" href="#" title="Hide" ng-click="go()" class="icon-eye-off" ng-class="{active: item.state == 'hidden'}"></a>
`;
